import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
/** Page navigation starts at the top; hash targets retain their own anchor handling. */
export function RouteScrollReset() {
  const { pathname, hash } = useLocation();
  useLayoutEffect(() => {
    if (!hash) window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
